/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2024-03-19 10:58:18
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-04-21 17:15:11
 * FilePath     :\AV-COM-user-backend\src\permission.js
 * RevisionHistory:
 */
import router from "./router";
import i18n from "@/lang/index";
import store from "./store/index";
import {
    softLogin
} from "@/api";
import cookies from "@/utils/cookies";

import {
    enterpriseRouter
} from "./router/enterprise";
import {
    personalRouter
} from "./router/personal";
import {
    roleMap
} from "@/utils/type-map";

const RouteView = {
    name: "RouteView",
    render: (h) => h("router-view"),
};

function filterRoutes(routes, group) {
    return routes.filter((route) => {
        if (route.meta.role) {
            if (
                (route.meta.type === "device" &&
                    !route.meta.role.includes(
                        roleMap[group.devicePermissions]
                    )) ||
                (route.meta.type === "user" &&
                    !route.meta.role.includes(roleMap[group.userPermissions]))
            ) {
                // 如果不符合条件，移除此路由
                return false;
            }
        }
        if (route.children) {
            // 递归处理子路由
            route.children = filterRoutes(route.children, group);
        }
        return true;
    });
}

const addRouters = (groupList) => {
    if (groupList.length > 0) {
        // if(isContain(enterpriseRouter.children, list))
        let list = [];
        groupList.forEach((item, index) => {
            const currentID = item.enterpriseID;
            const currentPath = "/:companyName/team";
            // 团队路由
            const teamRouter = {
                name: "team",
                path: currentPath,
                redirect: currentPath + "/device",
                component: RouteView,
                meta: {
                    name: "",
                    menue: true,
                    menuTxt: item.name,
                    enterpriseID: currentID,
                },
                children: [{
                        path: currentPath + "/information",
                        name: "TeamMember",
                        component: () => import("@/views/team/information"),
                        meta: {
                            name: i18n.t("menu.teamInformation"),
                            isEnterprise: true,
                            icon: "team",
                            menue: true,
                            menuTxt: i18n.t("menu.teamInformation"),
                        },
                    },
                    {
                        name: "device",
                        path: currentPath + "/device",
                        redirect: currentPath + "/device",
                        component: RouteView,
                        meta: {
                            name: i18n.t("menu.deviceManagement"),
                            icon: "device",
                            menue: true,
                            menuTxt: i18n.t("menu.deviceManagement"),
                        },
                        children: [{
                                path: currentPath + "/device",
                                name: "deviceList",
                                component: () =>
                                    import("@/views/team/device/deviceList"),
                                meta: {
                                    name: i18n.t("menu.devMagList"),
                                    isEnterprise: true,
                                    type: "device",
                                    role: ["manage", "view"],
                                    menuTxt: i18n.t("menu.DeviceList"),
                                },
                            },
                            {
                                path: currentPath + "/deploy",
                                name: "deviceDeploy",
                                component: () =>
                                    import("@/views/team/device/deploy"),
                                meta: {
                                    name: i18n.t("menu.devMagDeploy"),
                                    type: "device",
                                    isEnterprise: true,
                                    role: ["manage", "view", "not"],
                                    menuTxt: i18n.t("menu.deployDevice"),
                                },
                            },
                            {
                                path: currentPath + "/apply",
                                name: "apply",
                                component: () =>
                                    import(
                                        "@/views/team/device/deploy/DeployTable.vue"
                                    ),
                                meta: {
                                    name: i18n.t("menu.devMagApply"),
                                    isEnterprise: true,
                                    type: "device",
                                    role: ["manage"],
                                    menuTxt: i18n.t("menu.apply"),
                                },
                            },
                        ],
                    },
                    {
                        name: item.name,
                        path: currentPath + "/member",
                        redirect: currentPath + "/member",
                        component: RouteView,
                        meta: {
                            name: i18n.t("menu.memberManagement"),
                            type: "user",
                            role: ["manage", "view"],
                            icon: "users",
                            menuTxt: i18n.t("menu.memberManagement"),
                        },
                        children: [{
                                path: currentPath + "/member",
                                name: "TeamMember",
                                component: () => import("@/views/team/member/"),
                                meta: {
                                    name: i18n.t("role2"),
                                    isEnterprise: true,
                                    menuTxt: i18n.t("role1"),
                                },
                            },
                            {
                                path: currentPath + "/role",
                                name: "TeamRole",
                                component: () =>
                                    import("@/views/team/member/role"),
                                meta: {
                                    name: i18n.t("role3"),
                                    isEnterprise: true,
                                    menuTxt: i18n.t("rolePermissions"),
                                },
                            },
                        ],
                    },
                ],
            };

            teamRouter.children = filterRoutes(teamRouter.children, item);

            list.push(teamRouter);
        });
        enterpriseRouter.children = enterpriseRouter.children.concat(list);
        return enterpriseRouter;
    } else {
        // personalRouter需要处理一下不然不跳转
        personalRouter.children = personalRouter.children.concat([]);
        return personalRouter;
    }
};

// 解析url paramss，使用this.$route.query，Vue Router 内部被自动解码，未避免解码定义此方法
function getUrlParameter(name, url) {
    var e = url || window.location.search;
    var c = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var d = e.substr(1).match(c);
    if (d != null) {
        return decodeURIComponent(d[2]);
    }
    return null;
}

// 是否跳转到首页
const isGotoHome = (to, next) => {
    const toAryy = to.path.slice(1).split("/");
    if (
        toAryy[1] === "team" &&
        !store.state.enterprise.GROUP_LIST.some(
            (item) => item.enterpriseID == toAryy[0]
        )
    ) {
        return true;
    } else {
        return false;
    }
};

// 生成指定长度的随机字符串
function generateRandomString(length) {
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomIndex);
    }

    return result;
}
const searchStr = window.location.search || "";
// const softLoginToken = '';
router.beforeEach(async (to, from, next) => {
    // const token = to.query.token;
    console.log(
        to,
        store.state.userinfo.TOKEN,
        "=============router================",
        to.query.para
    );

    if ((to.query.para || to.query.em)) {
        try {
            // 有两个登录search参数em和para，有哪个参数用哪个，两个同时有用em
            const softRes = await softLogin({
                para: getUrlParameter("em") || getUrlParameter("para")
            });


            if (softRes.code === 200) {
                // softLoginToken = softRes.data.token

                cookies.set(
                    "request_token",
                    softRes.data.token + "." + generateRandomString(32), {
                        expires: 1,
                        path: "/",
                    }
                );
            } else {
                window.open(i18n.t("href.login") + searchStr, "_self");
                return;
            }
        } catch (error) {
            console.error(error);
            window.open(i18n.t("href.login") + searchStr, "_self");
            return;
        }
    }

    // 设置token
    store.commit("userinfo/SET_TOKEN");
    if (store.state.userinfo.TOKEN) {
        try {
            if (
                !store.state.userinfo.PERINFO ||
                store.state.enterprise.HAS_ROLE_CHANGE
            ) {
                await store.dispatch("userinfo/setPerinfo");
                await store.dispatch("enterprise/setGroupList");
                // 设置申请列表红点
                if (to.name !== "apply") {
                    store.dispatch("enterprise/getNewApplication");
                }

                store.commit("enterprise/UPDATE_ROLE_TYPE", false);
                const groupList = store.state.enterprise.GROUP_LIST;
                const routeObj = addRouters(groupList);
                console.log(groupList, routeObj, "addRouters");
                if (
                    router.options.routes.some((item) => item.name === "home")
                ) {
                    if (isGotoHome(to)) {
                        next("/userinfo");
                    } else {
                        next();
                    }
                } else {
                    router.options.routes.push(routeObj);
                    router.addRoute(routeObj);
                    router.addRoute({
                        path: "*",
                        redirect: "/userinfo",
                    });
                    if (isGotoHome(to)) {
                        next("/userinfo");
                    } else {
                        next({
                            ...to,
                            replace: true
                        });
                    }
                }
                console.log(router.options.routes, "beforeEach");
            } else {
                // 设置申请列表红点
                if (to.name !== "apply") {
                    store.dispatch("enterprise/getNewApplication");
                }
                if (isGotoHome(to)) {
                    next("/userinfo");
                } else {
                    next();
                }
            }

            console.log(router.options.routes, "beforeEach");
        } catch (error) {
            console.error(error);
            next(false); // 阻止路由导航
        }
    } else {
        if (to.path === "/login" || to.path === "/third-party") {
            // alert(111)
            next();
        } else {
            window.open(i18n.t("href.login") + searchStr, "_self");
        }
    }
});